import { render, staticRenderFns } from "./LanguageSelectButton.vue?vue&type=template&id=54394982&scoped=true&"
import script from "./LanguageSelectButton.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectButton.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectButton.vue?vue&type=style&index=0&id=54394982&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54394982",
  null
  
)

export default component.exports